import React from "react";
import { Helmet } from "react-helmet";
import Portal from "src/components/portal";
import DemoBarPersonal from "src/components/demo-bar-personal";
import DemoBarDemo from "src/components/demo-bar-demo";
import { ActiveIntegrationsProvider } from "src/scenes/dashboard/active-integrations-provider";
import styled from "styled-components";
import { Button, Grid, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import Icon from "src/components/icon";
import personalNavIcon from "src/assets/icons/personal-nav-icon";
import teamsNavIcon from "src/assets/icons/teams-nav-icon";
import reposNavIcon from "src/assets/icons/repos-nav-icon";
import CentrallyManaged from "src/scenes/dashboard/centrally-managed";
import overviewNavIcon from "src/assets/icons/overview-nav-icon";
import Link from "src/components/link";

const ButtonWithBorder = styled(Button)`
    border: 2px solid #ffffff14;
    border-radius: 14px;
    height: 220px;
    width: 220px;
    &:hover {
        border: 3px solid ${({ theme }) => theme.palette.primary.main};
    }
`;

const SubText = styled(Typography)`
    font-size: 12px;
    margin-top: 16px;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 200;
`;
const NavigationPage = () => {
    const availableDashboards = ["overview", "teams", "repo", "personal"];

    const getIcon = ({ dashboard }) => {
        if (dashboard === "personal") return personalNavIcon;
        if (dashboard === "teams") return teamsNavIcon;
        if (dashboard === "repo") return reposNavIcon;
        if (dashboard === "overview") return overviewNavIcon;
        return null;
    };

    const getSubText = ({ dashboard }) => {
        if (dashboard === "personal")
            return "Personalised data summary, insights, goals and recommendations";
        if (dashboard === "teams")
            return "Aggregate Work, Collaboration, and Wellbeing data per team";
        if (dashboard === "repo") return " Engineering metrics split by git repository";
        if (dashboard === "overview")
            return " Topline view of Engineering Effort Investment, Deliverables, and Cost";
        return null;
    };

    const getName = ({ dashboard }) => {
        if (dashboard === "personal") return "Personal";
        if (dashboard === "teams") return "Teams";
        if (dashboard === "repo") return "Repository";
        if (dashboard === "overview") return "Executive Overview";
        return null;
    };

    const handleRedirect = ({ dashboard }) => {
        if (dashboard === "personal") return "/dashboard/";
        if (dashboard === "teams") return "/teams";
        if (dashboard === "repo") return "/repo-view";
        if (dashboard === "overview") return "/overview";
        return null;
    };
    return (
        <ActiveIntegrationsProvider>
            <CentrallyManaged />
            <Helmet>
                <title>Adadot Navigate</title>
            </Helmet>
            <Portal>
                <DemoBarPersonal />
                <DemoBarDemo />
            </Portal>
            <Grid container justifyContent="center" style={{ width: "55%" }}>
                <Grid item md={12} mb={5}>
                    <Stack alignItems="center">
                        <Typography component="h1">Select a way to work with your data</Typography>
                    </Stack>
                </Grid>
                {availableDashboards.map((dashboard) => {
                    return (
                        <Grid item md={6} key={dashboard}>
                            <Stack alignItems="center">
                                <Link to={handleRedirect({ dashboard })} variant="plain">
                                    <Stack direction="column" alignItems="center">
                                        <ButtonWithBorder
                                            onClick={() => handleRedirect({ dashboard })}
                                        >
                                            <Stack alignItems="center" spacing={4}>
                                                <Icon
                                                    svg={getIcon({ dashboard })}
                                                    width="69px"
                                                    height="69px"
                                                    style={{ marginBottom: "12px" }}
                                                />
                                                {getName({ dashboard })}
                                            </Stack>
                                        </ButtonWithBorder>
                                    </Stack>
                                </Link>
                                <SubText style={{ marginBottom: "24px", width: "266px" }}>
                                    {getSubText({ dashboard })}
                                </SubText>
                            </Stack>
                        </Grid>
                    );
                })}
            </Grid>
        </ActiveIntegrationsProvider>
    );
};

export default NavigationPage;
